import { render, staticRenderFns } from "./patrolList-Info.vue?vue&type=template&id=5b50165e&scoped=true&"
import script from "./patrolList-Info.vue?vue&type=script&lang=js&"
export * from "./patrolList-Info.vue?vue&type=script&lang=js&"
import style0 from "./patrolList-Info.vue?vue&type=style&index=0&id=5b50165e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b50165e",
  null
  
)

export default component.exports